export default "__VITE_ASSET__7cYuPyZF__"